import { apiClient } from '../client';
import { Delegation } from '../../types/admin';

export const delegationsApi = {
  list: () => apiClient.get<{ data: Delegation[] }>('/api/admin/delegations'),
  create: (input: { delegatorUserId: number; delegateUserId: number; module?: string | null; startDate: string; endDate: string; reason?: string | null }) =>
    apiClient.post<{ data: { id: number } }>('/api/admin/delegations', input),
  cancel: (id: number) => apiClient.patch<{ data: { id: number; status: string } }>(`/api/admin/delegations/${id}/cancel`),
};
